import Vue, { ComponentOptions, AsyncComponent } from "vue";
import issue from "./issue";
import work from "./work";
import settings from "./settings";
import calendar from "./calendar";
import notice from "./notice";

export default [...issue, ...work, ...notice, ...calendar, ...settings];
